@let items = banners();
<section class="container px-0 px-sm-2 px-lg-3 bg-body">
  @if (items.length > 0) {
    <div class="banners-carousel__container">
      @for (item of items; track item.desktopLogo) {
        <div class="banners-carousel__item">
          @if (item.redirectUrl) {
            <a [href]="item.redirectUrl" target="_blank" rel="noopener noreferer">
              <ng-container
                *ngTemplateOutlet="tileImage; context: { item, i: $index }"
              ></ng-container>
            </a>
          } @else {
            <ng-container
              *ngTemplateOutlet="tileImage; context: { item, i: $index }"
            ></ng-container>
          }
        </div>
      }
    </div>

    <ng-template #tileImage let-item="item" let-i="i">
      <picture>
        <source [srcset]="item.mobileLogo" media="(max-width: 767px)" />

        <img
          [src]="item.desktopLogo"
          [alt]="item?.alt || 'Imagen promocional'"
          [id]="'home-banner-' + i"
          class="banners-carousel__img shadow-sm"
          decoding="async"
          loading="eager"
        />
      </picture>
    </ng-template>
  } @else {
    <div class="carousel__placeholders d-flex d-md-none placeholder-glow py-4 px-3">
      <ng-container *ngTemplateOutlet="skeletonCard"></ng-container>
    </div>

    <div class="carousel__placeholders d-none d-md-flex row placeholder-wave">
      @for (_ of placeholders(); track $index) {
        <div class="col-12 col-md-3 py-3">
          <ng-container *ngTemplateOutlet="skeletonCard"></ng-container>
        </div>
      }
    </div>
  }

  <ng-template #skeletonCard>
    <span
      class="banners-carousel__placeholder placeholder ratio ratio-4x3"
      aria-hidden="true"
    ></span>
  </ng-template>
</section>
